import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { supabase } from "utils/supabase";
import enarmApexLogo from "assets/img/enarm-apex-logo.png";

export default function RestablecerContrasena() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    const hashParams = new URLSearchParams(hash);
    const errorDescription = hashParams.get("error_description");

    if (errorDescription) {
      const decodedError = decodeURIComponent(errorDescription);
      if (decodedError === "Email link is invalid or has expired") {
        setErrorMessage("Link de correo invalido o expirado");
      } else {
        setErrorMessage(decodedError);
      }
    }
  }, []);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (!password || !confirmPassword) {
      setErrorMessage("Por favor completa todos los campos.");
      return;
    }

    if (password.length < 6) {
      setErrorMessage("La contrasena debe tener al menos 6 caracteres.");
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage("Las contrasenas no coinciden.");
      return;
    }

    setLoading(true);

    const { error } = await supabase.auth.updateUser({
      password,
    });

    setLoading(false);

    if (error) {
        if (error.message === "New password should be different from the old password.") {
            setErrorMessage("La nueva contraseña debe ser diferente a la anterior.");
            return;
        }
        setErrorMessage("No pudimos actualizar la contraseña. Solicita un nuevo enlace.");
        console.error(error);
        return;
    }

    setSuccessMessage("Contraseña actualizada correctamente. Ahora puedes iniciar sesión.");
    setPassword("");
    setConfirmPassword("");

    await supabase.auth.signOut();
    history.push("/auth/login");
  };

  return (
    <>
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-start items-start justify-center h-full">
          <div className="w-full lg:w-4/12 px-4 -mt-20">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <img
                    src={enarmApexLogo}
                    alt="ENARM Apex Logo"
                    className="w-32 mx-auto"
                    style={{ width: "20rem" }}
                  />
                  <br />
                  <h6 className="text-blueGray-500 text-lg font-bold">
                    Restablecer contraseña
                  </h6>
                  <p className="text-sm text-blueGray-500 mt-2">
                    Escribe tu nueva contraseña para completar la recuperación.
                  </p>
                </div>
              </div>

              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form onSubmit={handleResetPassword}>
                  {successMessage && (
                    <Alert severity="success" className="mb-4">
                      {successMessage}
                    </Alert>
                  )}

                  {errorMessage && (
                    <Alert severity="error" className="mb-4">
                      {errorMessage}
                    </Alert>
                  )}

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="new-password"
                    >
                      Nueva contraseña
                    </label>
                    <input
                      id="new-password"
                      type="password"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Nueva contraseña"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="confirm-password"
                    >
                      Confirmar contraseña
                    </label>
                    <input
                      id="confirm-password"
                      type="password"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Confirmar contraseña"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </div>

                  <div className="text-center mt-6">
                    <button
                      className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150 disabled:opacity-60"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Actualizando..." : "Guardar nueva contraseña"}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="text-center mt-2">
              <Link to="/auth/login" className="text-blueGray-200">
                <small>Volver a iniciar sesion</small>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
